import script from "./MainFunctionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFunctionsSection.vue?vue&type=script&setup=true&lang=js"

import "./MainFunctionsSection.vue?vue&type=style&index=0&id=5cbea890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbea890"]])

export default __exports__